import { Injectable } from '@angular/core';
import { SlWapiService } from '../model/api-services/sl-wapi.service';

@Injectable({
	providedIn: 'root'
})
export class PermissionService {

	protected static permissions: any;
	static NONE = 0;
	static VIEW = 1;
	static EDIT = 2;
	static COPY = 4;
	static CREATE = 8;
	static SAVE = 16;
	static DELETE = 32;
	static FULL = 63;
	constructor() { }

	static GetPermission(permName:string,permSet?:any) : number | false {
    if(!permSet) permSet = PermissionService.permissions;
		if (!permSet) {
			PermissionService.permissions = SlWapiService.SLSESSION.permissions;
			(window as any).SLPermissions = PermissionService.permissions;
      permSet = PermissionService.permissions;
		}
		return (!!permSet && !!permSet[permName]) ? permSet[permName] : false;
	}
	static HasPermission(permName:string,permValue:number) {
		const permission = PermissionService.GetPermission(permName);
		if(permission === false) {
			return false;
		}
		return (permission & permValue) === permValue;
	}
	static NeedsPermission(permName:string,permValue:number) {
		return !PermissionService.HasPermission(permName,permValue);
	}
}
